import React, { Component } from 'react';
import '../styles/css/app.css';
import parse from 'html-react-parser';


class BlogPage extends Component {
  constructor(props){
    super(props);
    this.state ={ 
      isLoadingComplete: false,
    }
  }

  render() {

    // console.log(this.props.apiData[0])
    let id = this.props.match.params.id
    const filterBlogPost = this.props.apiData.filter(post => id === post._id)[0]
    // const blogPost = this.props.apiData[0]

    return (
      <div>
      {this.props.isLoadingComplete ? 
        <div className="blog-container">
        <article className="blog-body">
            <h1>{filterBlogPost.title}</h1>
      {filterBlogPost.image ? <img style={{width:"80vh"}} src={filterBlogPost.image} /> : <br/>} 
          <div style={{marginTop: "2em"}}>{parse(filterBlogPost.body)}</div>
          </article>
          </div>:

        <article className="blogBody">

          </article>}

      </div>


    );
  }
}

export default BlogPage;
